/* ZINKE — Produktgalerie, 16.09.2026
   ===================================

   Was diese Datei macht, und warum

   1. REIHENFOLGE. Bisher stand die Galerie in der Reihenfolge, in der die
      Bilder im Admin liegen: erst alle Farben, dann irgendwann die Grafiken
      mit den Vorzügen. Wer sich durchklickt, sieht also fünfmal dasselbe
      Produkt in anderer Farbe, bevor überhaupt ein Verkaufsargument kommt.
      Ab hier gilt: das Bild der GEWÄHLTEN Farbe steht vorn, dahinter die
      Grafiken, und erst danach die übrigen Farben.

   2. FARBE MITWÄHLEN. Blättert jemand auf das Bild einer anderen Farbe,
      wird diese Farbe auch in der Auswahl gesetzt. Vorher musste man das
      Bild suchen UND die Farbe getrennt auswählen.

   3. PFEILE. Links und rechts über dem Hauptbild, damit man durchblättern
      kann, ohne die kleine Bildleiste zu treffen.

   Wie es zusammenspielt

   Die eigentliche Bildumschaltung bleibt in zinke.js (showMedia). Diese Datei
   fasst sie nicht an, sondern klickt die passende Schaltfläche in der
   Bildleiste an — damit gibt es genau einen Weg, ein Bild zu zeigen, und
   keine zwei Zustände, die auseinanderlaufen können.

   Den Variantenwechsel löst ebenfalls zinke.js aus (changeVariant), sobald
   sich ein Options-Auswahlfeld ändert. Auch das wird hier nur angestoßen,
   nicht nachgebaut. Eine Schleife entsteht nicht: changeVariant ruft am Ende
   showMedia direkt auf, nicht über einen Klick.

   Die Daten kommen aus einem JSON-Block, den sections/main-product.liquid
   mitrendert. Ohne diesen Block tut die Datei nichts. */

(() => {
  'use strict';

  const alle = (wahl, wurzel = document) => Array.from(wurzel.querySelectorAll(wahl));

  /* ---------------------------------------------------------------- Daten */

  function datenLesen(wurzel) {
    const knoten = wurzel.querySelector('[data-zinke-galerie]');
    if (!knoten) return null;
    try {
      const d = JSON.parse(knoten.textContent);
      if (!d || !Array.isArray(d.medien)) return null;
      return d;
    } catch (fehler) {
      return null;
    }
  }

  /* Welches Medium gehört zu welcher Variante, und umgekehrt. */
  function tabellen(daten) {
    const mediumZuVariante = new Map();
    const variantenMedien = new Set();
    (daten.varianten || []).forEach(v => {
      if (!v.medium) return;
      const id = String(v.medium);
      variantenMedien.add(id);
      if (!mediumZuVariante.has(id)) mediumZuVariante.set(id, v);
    });
    const wertIds = (daten.optionswerte || []).map(o => ({
      position: o.position,
      werte: o.werte || {},
    }));
    return { mediumZuVariante, variantenMedien, wertIds };
  }

  /* -------------------------------------------------------- Reihenfolge */

  /* gewähltes Farbbild → geteilte Medien → übrige Farbbilder */
  function reihenfolgeBauen(daten, t, aktivesMedium) {
    const medien = daten.medien.map(String);
    const vorn = [];
    const geteilt = [];
    const rest = [];

    medien.forEach(id => {
      if (aktivesMedium && id === String(aktivesMedium)) vorn.push(id);
      else if (t.variantenMedien.has(id)) rest.push(id);
      else geteilt.push(id);
    });

    return vorn.concat(geteilt, rest);
  }

  function aktivesMediumFinden(wurzel, daten, t) {
    // Erst die tatsächlich gewählte Variante, das ist die verlässliche Quelle.
    const feld = wurzel.querySelector('[data-variant-id]');
    if (feld && feld.value) {
      const treffer = (daten.varianten || []).find(v => String(v.id) === String(feld.value));
      if (treffer && treffer.medium) return String(treffer.medium);
    }
    // Sonst das Bild, das gerade sichtbar ist.
    const sichtbar = wurzel.querySelector('[data-media-id]:not([hidden])');
    return sichtbar ? String(sichtbar.dataset.mediaId) : null;
  }

  function streifenSortieren(wurzel, folge) {
    const streifen = wurzel.querySelector('.product-thumbnail-list');
    if (!streifen) return;
    folge.forEach(id => {
      const knopf = streifen.querySelector('[data-thumbnail="' + CSS.escape(id) + '"]');
      if (knopf) streifen.appendChild(knopf);
    });
  }

  /* ------------------------------------------------------------- Zähler */

  function zaehlerSetzen(wurzel) {
    const zaehler = wurzel.querySelector('[data-galerie-zaehler]');
    if (!zaehler) return;
    const knoepfe = alle('[data-thumbnail]', wurzel);
    if (!knoepfe.length) return;
    const stelle = knoepfe.findIndex(k => k.getAttribute('aria-pressed') === 'true');
    zaehler.textContent = (stelle < 0 ? 1 : stelle + 1) + ' / ' + knoepfe.length;
  }

  /* -------------------------------------------------------------- Pfeile */

  function blaettern(wurzel, schritt) {
    const knoepfe = alle('[data-thumbnail]', wurzel);
    if (knoepfe.length < 2) return;
    let stelle = knoepfe.findIndex(k => k.getAttribute('aria-pressed') === 'true');
    if (stelle < 0) stelle = 0;
    const ziel = (stelle + schritt + knoepfe.length) % knoepfe.length;
    knoepfe[ziel].click();
  }

  /* -------------------------------------------- Farbe zum Bild mitwählen */

  function varianteWaehlen(wurzel, mediumId) {
    const daten = datenLesen(wurzel);
    if (!daten) return;
    const t = tabellen(daten);
    const variante = t.mediumZuVariante.get(String(mediumId));
    if (!variante || !Array.isArray(variante.optionen)) return;

    let letztes = null;
    variante.optionen.forEach((text, i) => {
      const eintrag = t.wertIds[i];
      if (!eintrag) return;
      const wertId = eintrag.werte[text];
      if (wertId === undefined || wertId === null) return;
      const feld = wurzel.querySelector('[data-option-select][data-position="' + eintrag.position + '"]');
      if (!feld) return;
      if (String(feld.value) === String(wertId)) return;
      feld.value = String(wertId);
      letztes = feld;
    });

    // Ein einziges change-Ereignis genügt: changeVariant liest ohnehin alle
    // Auswahlfelder auf einmal aus.
    if (letztes) letztes.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* --------------------------------------------- Symbole in den Kacheln */

  function kachelnZeichnen(wurzel) {
    const kacheln = alle('.zinke-highlight', wurzel);
    if (!kacheln.length) return;

    const ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || ruhig) {
      kacheln.forEach(k => k.classList.add('ist-sichtbar'));
      return;
    }

    const beobachter = new IntersectionObserver(eintraege => {
      eintraege.forEach(e => {
        if (!e.isIntersecting) return;
        e.target.classList.add('ist-sichtbar');
        beobachter.unobserve(e.target);
      });
    }, { threshold: 0.35, rootMargin: '0px 0px -8% 0px' });

    kacheln.forEach(k => beobachter.observe(k));

    // Sicherheitsnetz: Was nach drei Sekunden noch nicht gezeichnet ist, wird
    // sichtbar gemacht. Besser ein fertiges Symbol als ein leeres Feld.
    setTimeout(() => kacheln.forEach(k => k.classList.add('ist-sichtbar')), 3000);
  }

  /* ------------------------------------------------------------- Aufbau */

  function aufbauen(wurzel) {
    const daten = datenLesen(wurzel);
    if (!daten) return;
    const t = tabellen(daten);
    const aktiv = aktivesMediumFinden(wurzel, daten, t);
    streifenSortieren(wurzel, reihenfolgeBauen(daten, t, aktiv));
    zaehlerSetzen(wurzel);
  }

  function starten(bereich = document) {
    alle('[data-product-root]', bereich).forEach(wurzel => {
      aufbauen(wurzel);
      kachelnZeichnen(wurzel);
    });
  }

  /* ------------------------------------------------------------ Bindung */

  document.addEventListener('click', event => {
    const pfeilZurueck = event.target.closest('[data-galerie-zurueck]');
    if (pfeilZurueck) {
      const wurzel = pfeilZurueck.closest('[data-product-root]');
      if (wurzel) blaettern(wurzel, -1);
      return;
    }

    const pfeilVor = event.target.closest('[data-galerie-vor]');
    if (pfeilVor) {
      const wurzel = pfeilVor.closest('[data-product-root]');
      if (wurzel) blaettern(wurzel, 1);
      return;
    }

    const kleinbild = event.target.closest('[data-thumbnail]');
    if (kleinbild) {
      const wurzel = kleinbild.closest('[data-product-root]');
      if (!wurzel) return;
      // zinke.js hat das Bild in derselben Klickrunde bereits umgeschaltet.
      varianteWaehlen(wurzel, kleinbild.dataset.thumbnail);
      zaehlerSetzen(wurzel);
    }
  });

  // Nach einem Variantenwechsel neu sortieren: die neue Farbe gehört nach vorn.
  document.addEventListener('zinke:variant:change', event => {
    const id = event.detail && event.detail.sectionId;
    const wurzel = id
      ? document.querySelector('[data-product-root][data-section-id="' + CSS.escape(id) + '"]')
      : document.querySelector('[data-product-root]');
    if (!wurzel) return;
    aufbauen(wurzel);
    kachelnZeichnen(wurzel);
  });

  document.addEventListener('shopify:section:load', event => starten(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => starten());
  } else {
    starten();
  }
})();

/* ZINKE — Produktseite, Handgriffe am Aufbau (16.09.2026, geändert 17.09.2026)
   ===========================================================================

   A) HANDY: Der Beschreibungsblock „Details" steht im Quelltext mit dem
      Attribut `open` da. Seit die Keypoints darüber stehen, ist das Doppelung:
      man scrollt an ausgeklapptem Fließtext vorbei. Auf dem Handy wird er
      deshalb beim Laden einmal zugeklappt — per JavaScript und nicht per CSS,
      weil `display:none` auf den Inhalt den Aufklapper danach kaputtmacht.

   B) LAPTOP (ab 750 px): „Passt dazu" kommt in die rechte Spalte unter den
      Kaufbereich (Platzhalter [data-product-quer] in main-product.liquid).
      Links stehen Merkmale und Beschreibung, rechts wäre sonst nach dem
      Kaufbereich nur leere Fläche. Verschoben wird das <section>-Element
      selbst; die leere Abschnittshülle von Shopify bleibt an ihrem Platz,
      damit der Theme-Editor die Reihenfolge weiter kennt. Unter 750 px wandert
      der Block zurück ans Seitenende.
      Bis 17.09. früh wurde er in die LINKE Spalte unter die Galerie gesetzt —
      dort hatte er mehr Gewicht als die eigenen Merkmale. */
(() => {
  'use strict';

  const SCHMAL = '(max-width: 749px)';
  let heimat = null;   // ursprünglicher Elternknoten des Cross-Selling-Blocks

  function detailsSchliessen() {
    // 4.6: „Die Details" bleibt am Handy offen – die Beschreibung ist das
    // stärkste Argument fürs Produkt und steht jetzt direkt unter den Vorteilen.
    return;
    if (!window.matchMedia(SCHMAL).matches) return;
    const erste = document.querySelector('.product-mehr .product-accordion[open], .product-info .product-accordion[open]');
    if (erste) erste.open = false;
  }

  function querVerschieben() {
    const ziel = document.querySelector('[data-product-quer]');
    const block = document.querySelector('section.crosssell[data-crosssell]');
    if (!ziel || !block) return;
    if (heimat === null || !heimat.isConnected) {
      if (block.parentElement !== ziel) heimat = block.parentElement;
    }

    if (!window.matchMedia(SCHMAL).matches) {
      if (block.parentElement !== ziel) {
        ziel.appendChild(block);
        block.classList.add('crosssell-seitlich');
      }
    } else if (block.parentElement === ziel && heimat) {
      heimat.appendChild(block);
      block.classList.remove('crosssell-seitlich');
    }
  }

  function starten() {
    detailsSchliessen();
    querVerschieben();
  }

  let takt;
  window.addEventListener('resize', () => {
    clearTimeout(takt);
    takt = setTimeout(querVerschieben, 150);
  });

  // Lädt der Theme-Editor einen Abschnitt neu, ist der alte Knoten weg.
  document.addEventListener('shopify:section:load', () => {
    heimat = null;
    querVerschieben();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }
})();

/* ZINKE — Kaufbereich gegen „Benachrichtige mich" tauschen (16.09.2026)
   ====================================================================

   Liquid rendert den Zustand fuer die Variante, die beim Seitenaufbau gewaehlt
   ist. Wechselt jemand danach die Farbe, muss der Tausch nachgezogen werden.

   Beobachtet wird dafuer der Kaufen-Button und nicht das Variantenereignis:
   zinke.js schaltet dort ohnehin schon `disabled` um, und an dieser einen
   Eigenschaft haengt die Entscheidung eindeutig — egal, welches Skript sie
   gesetzt hat. Ein MutationObserver ist hier billiger und verlaesslicher als
   eine zweite Stelle, die dieselbe Verfuegbarkeitslogik nachbaut.

   KORREKTUR 22.09.2026 (Theme 6.8) — „Gerade ausverkauft" blitzte auf
   --------------------------------------------------------------------
   Die Annahme oben war falsch: `disabled` heisst nicht nur „ausverkauft",
   sondern auch „gerade beschaeftigt". assets/zinke-addon.js setzt beim Klick
   auf „In den Warenkorb" genau dieses Attribut als Doppelklickschutz
   (button.disabled = true), ruft /cart/add.js auf und nimmt es im finally
   wieder zurueck. Dieser Beobachter las das als „ausverkauft", blendete das
   E-Mail-Formular ein und die Kaufzeile samt Zahlungsknopf aus — sichtbar,
   solange der Aufruf lief. Im WLAN ein Zucken, auf Mobilfunk auch mal eine
   Sekunde, in der dem Kunden mitten im Kauf gesagt wird, der Artikel sei weg.

   Gegenmassnahme: Das EINBLENDEN wird um 900 ms verzoegert. Wird der Knopf
   innerhalb dieser Zeit wieder aktiv — der Normalfall bei einem laufenden
   Aufruf — passiert gar nichts. Das AUSBLENDEN bleibt sofort, damit die
   Kaufzeile nach einem Variantenwechsel ohne Verzoegerung zurueckkommt.
   Der Erstzustand beim Anhaengen wird ebenfalls sofort gesetzt: er kommt aus
   Liquid und ist verlaesslich, ein wirklich ausverkaufter Artikel soll seine
   Kaufzeile nicht erst 900 ms lang zeigen.

   KORREKTUR 28.09.2026 (Theme 8.7) — die 900 ms waren nur eine Schwelle
   --------------------------------------------------------------------
   Am 28.09. um 11:01 kam ueber das Kontaktformular eine Anfrage nach
   Benachrichtigung bei Wiederverfuegbarkeit fuer die Brogues in Schwarz 38 —
   zu einem Zeitpunkt, an dem davon 6045 Paar auf Lager standen. Der Kunde
   wollte kaufen und hat "Sold out right now" gelesen.

   Ursache: jede /cart/add.js-Anfrage, die laenger als 900 ms braucht, laeuft
   in denselben Fehlalarm wie vor der Korrektur vom 22.09. Auf Mobilfunk ist
   das keine Ausnahme, und 94 % der Besucher sind am Handy.

   Die Wartezeit ist deshalb nicht mehr die Entscheidungsgrundlage, sondern nur
   noch ein Sicherheitsnetz: assets/zinke-addon.js setzt am Kaufen-Knopf
   zusaetzlich data-laeuft="ja", solange sein Aufruf laeuft, und nimmt es im
   finally wieder weg. Solange diese Markierung steht, gilt der Knopf als
   beschaeftigt und nicht als ausverkauft — unabhaengig davon, wie langsam die
   Verbindung ist. Beobachtet wird jetzt auch data-laeuft, damit die
   Reihenfolge der beiden Attributaenderungen keine Rolle spielt. */
(() => {
  'use strict';

  const WARTEN = 900;
  const timer = new WeakMap();

  function anwenden(info) {
    const knopf = info.querySelector('[data-add-button]');
    const block = info.querySelector('[data-nachricht]');
    if (!knopf || !block) return;

    const ausverkauft = knopf.disabled && knopf.dataset.laeuft !== 'ja';
    block.hidden = !ausverkauft;

    const kaufzeile = info.querySelector('.buy-row');
    if (kaufzeile) kaufzeile.hidden = ausverkauft;

    const zahlknopf = info.querySelector('.shopify-payment-button');
    if (zahlknopf) zahlknopf.hidden = ausverkauft;
  }

  /* Aus dem Beobachter heraus: ausblenden sofort, einblenden verzoegert. */
  function schalten(info) {
    const knopf = info.querySelector('[data-add-button]');
    if (!knopf) return;
    clearTimeout(timer.get(info));
    // Nicht deaktiviert, oder nur beschaeftigt: sofort anwenden, kein Warten.
    if (!knopf.disabled || knopf.dataset.laeuft === 'ja') { anwenden(info); return; }
    timer.set(info, setTimeout(() => anwenden(info), WARTEN));
  }

  function anhaengen(info) {
    if (info.dataset.zinkeNachricht === 'ja') return;
    const knopf = info.querySelector('[data-add-button]');
    if (!knopf) return;
    info.dataset.zinkeNachricht = 'ja';
    new MutationObserver(() => schalten(info))
      .observe(knopf, { attributes: true, attributeFilter: ['disabled', 'data-laeuft'] });
    anwenden(info);
  }

  function starten(bereich) {
    (bereich || document).querySelectorAll('[data-product-info]').forEach(anhaengen);
  }

  document.addEventListener('shopify:section:load', event => starten(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => starten());
  } else {
    starten();
  }
})();